__turbopack_context__.v({
  "article": "CBlog-module__hVkBrq__article",
  "articleAuthor": "CBlog-module__hVkBrq__articleAuthor",
  "articleBack": "CBlog-module__hVkBrq__articleBack",
  "articleBackLink": "CBlog-module__hVkBrq__articleBackLink",
  "articleCategories": "CBlog-module__hVkBrq__articleCategories",
  "articleCategory": "CBlog-module__hVkBrq__articleCategory",
  "articleDate": "CBlog-module__hVkBrq__articleDate",
  "articleHeader": "CBlog-module__hVkBrq__articleHeader",
  "articleLead": "CBlog-module__hVkBrq__articleLead",
  "articleMainImage": "CBlog-module__hVkBrq__articleMainImage",
  "articleMeta": "CBlog-module__hVkBrq__articleMeta",
  "articleTitle": "CBlog-module__hVkBrq__articleTitle",
  "body": "CBlog-module__hVkBrq__body",
  "card": "CBlog-module__hVkBrq__card",
  "cardLink": "CBlog-module__hVkBrq__cardLink",
  "date": "CBlog-module__hVkBrq__date",
  "empty": "CBlog-module__hVkBrq__empty",
  "list": "CBlog-module__hVkBrq__list",
  "more": "CBlog-module__hVkBrq__more",
  "pagination": "CBlog-module__hVkBrq__pagination",
  "paginationHint": "CBlog-module__hVkBrq__paginationHint",
  "paginationInfo": "CBlog-module__hVkBrq__paginationInfo",
  "root": "CBlog-module__hVkBrq__root",
  "short": "CBlog-module__hVkBrq__short",
  "thumb": "CBlog-module__hVkBrq__thumb",
  "thumbWrap": "CBlog-module__hVkBrq__thumbWrap",
  "title": "CBlog-module__hVkBrq__title",
});
